module.exports = __webpack_public_path__ + "media/gallery/3-b92bc075.jpg";